module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p7-4ec8f0dff6ddf6176706dc3305331dbf.png";